module.exports = __webpack_public_path__ + "static/media/focus-icon-3.d1745f42.avif";